"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.waitFor = exports.WaitForTimeoutError = void 0;
exports.sleep = sleep;
function sleep(ms) {
    return new Promise((resolve) => {
        setTimeout(resolve, ms);
    });
}
class WaitForTimeoutError extends Error {
    constructor(message) {
        super(message);
        this.name = "WaitForTimeoutError";
    }
}
exports.WaitForTimeoutError = WaitForTimeoutError;
const waitFor = async ({ condition, timeout = 10_000, }) => {
    const deadline = Date.now() + timeout;
    while (!(await condition())) {
        if (Date.now() >= deadline) {
            throw new WaitForTimeoutError(`Timeout of ${timeout} milliseconds exceeded waiting for condition to be true.`);
        }
        else {
            await sleep(100);
        }
    }
};
exports.waitFor = waitFor;
//# sourceMappingURL=promises.js.map